module.exports = __webpack_public_path__ + "frontend/images/homepage/carousel/desktop/0@2.gif?56d165c50fbe30f28dbfe94d2da95f56";